import { User } from '../../user/User.interface';
import { TaskType, TaskTypeEntity } from '../task-types/TaskType.interface';

export enum WorkflowEntity {
  Any = '',
  Training = 'training',
  Risk = 'risk',
  File = 'file',
  Capa = 'capa',
  Supplier = 'supplier',
  Scar = 'scar',
  Spor = 'spor',
  Product = 'product',
  UserNeed = 'user-need',
  DesignOutput = 'design-output',
  DesignInput = 'design-input',
  DesignVerification = 'design-verification',
  DesignValidation = 'design-validation',
  DesignSpec = 'design-spec',
  Hazard = 'hazard',
  Cause = 'cause',
  Control = 'control',
  Action = 'action',
  ChangeOrder = 'change-order'
}

export type WorkflowTaskTypeEntity = WorkflowEntity | TaskTypeEntity;

export const workflowEntities = [
  { value: WorkflowEntity.Any, label: 'Any' },
  { value: WorkflowEntity.Training, label: 'Training' },
  { value: WorkflowEntity.Risk, label: 'Risk' },
  { value: WorkflowEntity.File, label: 'File' },
  { value: WorkflowEntity.Capa, label: 'CAPA' },
  { value: WorkflowEntity.Supplier, label: 'Supplier' },
  { value: WorkflowEntity.Scar, label: 'SCAR' },
  { value: WorkflowEntity.Spor, label: 'SPOR' },
  { value: WorkflowEntity.Product, label: 'Product' },
  { value: WorkflowEntity.UserNeed, label: 'Product User Need' },
  { value: WorkflowEntity.DesignInput, label: 'Product Design Input' },
  { value: WorkflowEntity.DesignOutput, label: 'Product Design Output' },
  { value: WorkflowEntity.DesignVerification, label: 'Product Verification' },
  { value: WorkflowEntity.DesignValidation, label: 'Product Validation' },
  { value: WorkflowEntity.DesignSpec, label: 'Design Specification' },
  { value: WorkflowEntity.Hazard, label: 'Hazard' },
  { value: WorkflowEntity.Cause, label: 'Hazard Cause' },
  { value: WorkflowEntity.Control, label: 'Hazard Control' },
  { value: WorkflowEntity.Action, label: 'Hazard Action' },
  { value: WorkflowEntity.ChangeOrder, label: 'Change Order' }
];

export enum WorkflowStatus {
  Draft = 'draft',
  Published = 'published'
}

export interface WorkflowStatusLog {
  id: number;
  version: number;
  status: string;
  created: Date;
  createdBy: User;
}

export interface WorkflowVersion {
  id: number;
  workflowId: number;
  name: string;
  entity: WorkflowEntity;
  workflow?: WorkflowDto;
  description: string;
  config: any;
  version: number;
  createdBy: User;
  created: Date;
}

export interface WorkflowDto {
  id: number;
  name: string;
  /**
   * @deprecated
   */
  entity: WorkflowEntity;
  taskType?: TaskType;
  taskTypeName?: string | null;
  description?: string;
  version: number;
  status: WorkflowStatus;
  config?: any;
  isDeleted?: boolean;
  created?: Date;
  createdBy?: User;
  modified?: Date;
  modifiedBy?: User;
}

export interface WorkflowListItem {
  id: number | string;
  apiLevel: 1 | 2;
  name: string;
  taskType: string;
  version: number;
  status: string;
  modified: Date;
  modifiedBy: User;
}

export enum TransitionCondition {
  RequireFields = 'require-fields',
  Confirm = 'confirm',
  Signature = 'signature',
  CheckSubTasks = 'check-subtasks',
  CheckTeam = 'check-team'
}

export const transitionConditions = [
  { value: TransitionCondition.RequireFields, label: 'Require Fields' },
  { value: TransitionCondition.Confirm, label: 'Confirm Dialog' },
  { value: TransitionCondition.Signature, label: 'Electronic Signature' },
  { value: TransitionCondition.CheckSubTasks, label: 'Check SubTasks' },
  { value: TransitionCondition.CheckTeam, label: 'Check Team Permission' }
];

export enum WorkflowInvokeAction {
  None = '',
  CreateSubTasks = 'createSubTasks',
  RemoveSubTasks = 'removeSubTasks',
  UpdateJiraIssue = 'updateJiraIssue',
  SendEmail = 'sendEmail'
}

export const workflowInvokeActions = [
  { value: WorkflowInvokeAction.None, label: 'None' },
  { value: WorkflowInvokeAction.CreateSubTasks, label: 'Create SubTasks' },
  { value: WorkflowInvokeAction.RemoveSubTasks, label: 'Remove SubTasks' },
  { value: WorkflowInvokeAction.UpdateJiraIssue, label: 'Update Jira Issue' },
  { value: WorkflowInvokeAction.SendEmail, label: 'Send Email' }
];

export interface WorkflowInvokeEvent {
  event: string;
  description: string;
}

export interface BaseWorkflowTabProps {
  workflow: WorkflowDto;
  onChange?: (workflow: Partial<WorkflowDto>) => void;
}
